import * as angular from "angular";
import {IController} from "angular";
import {SortType} from "../../../commons/types/sort.type";

export class customersTableCtrl implements IController {

  queryString: any;
  doReload: any;
  accountIds: any;
  onDelete: Function;
  onReload: Function;

  private customersRef: any;
  private loadLimit: any;
  private infiniteScroll: any;
  public isScrollable: boolean;
  public businessNameSortType: string;
  public firstNameSortType: string;
  public lastNameSortType: string;
  public addressSortType: string;
  public asceDescIconsMap: any;


  /* @ngInject */
  constructor(private $customers, private $infiniteScroll, private $log, private $mdMedia, private commonsConstants) {
  }

  $onInit() {
    this.asceDescIconsMap = this.commonsConstants.sortIconsMap;

    this.customersRef = this.$customers();
    this.loadLimit = 30;

    this.customersRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.customersRef, this.loadLimit);
  }

  $onChanges(changes) {
    if (changes.queryString && !changes.queryString.isFirstChange()) {
      this._reloadQuery()
    }
    if (changes.doReload && !changes.doReload.isFirstChange()) {
      if (this.doReload) {
        this._reloadQuery()
      }
    }
  };

  $doCheck() {
    this.isScrollable = !this.$mdMedia('gt-md');
  };

  onToggleFirstNameSortType() {
    this.lastNameSortType = undefined;
    this.businessNameSortType = undefined;
    this.addressSortType = undefined;
    this.firstNameSortType = this.firstNameSortType ? (this.firstNameSortType === SortType.asc ? SortType.desc : SortType.asc) : SortType.asc;
    this._reloadQuery();
  }

  onToggleLastNameSortType() {
    this.firstNameSortType = undefined;
    this.businessNameSortType = undefined;
    this.addressSortType = undefined;
    this.lastNameSortType = this.lastNameSortType ? (this.lastNameSortType === SortType.asc ? SortType.desc : SortType.asc) : SortType.asc;
    this._reloadQuery();
  }

  onToggleBusinessNameSortType() {
    this.addressSortType = undefined;
    this.firstNameSortType = undefined;
    this.lastNameSortType = undefined;

    this.businessNameSortType = this.businessNameSortType ? (this.businessNameSortType === SortType.asc ? SortType.desc : SortType.asc) : SortType.asc;
    this._reloadQuery();
  }

  // onToggleDefaultAddressSortType() {
  //   this.businessNameSortType = undefined;
  //   this.nameSortType = undefined;
  //   this.addressSortType = this.addressSortType ? (this.addressSortType === SortType.asc ? SortType.desc : SortType.asc) : SortType.asc;
  //
  //   this._reloadQuery();
  // }

  private _reloadQuery() {
    this.customersRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
        this.onReload();
      })
      .catch((error) => {
        this.$log.debug('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      query: this.queryString,
      accountIds: this.accountIds,
      limit: this.loadLimit,
      sort: this._getSortType()
    }
  }

  private _getSortType() {
    if (this.firstNameSortType) {
      return 'firstName,' + this.firstNameSortType;
    } if (this.lastNameSortType) {
      return 'lastName,' + this.lastNameSortType;
    } else if (this.businessNameSortType) {
      return 'businessName,' + this.businessNameSortType;
    } else if (this.addressSortType) {
      return 'address,' + this.addressSortType
    } else {
      return undefined;
    }
  }

}

angular
  .module('bringoz.admin.customers')
  .component('customersTable', {
    bindings: {
      queryString: '<',
      doReload: '<',
      accountIds: '<?',
      onEdit: '&',
      onDelete: '&',
      onReload: '&'
    },
    template: require('./customers-table.html').default,
    controller: customersTableCtrl
  });
